import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import fitty from 'fitty';

import { IRootState } from 'store/serverInterfaces';

import './CardImageTextArea.scss';

interface ICardImageTextArea {
  image?: string;
  topHtml?: any;
  middleHtml?: any;
  bottomHtml?: any;
  addGlint?: boolean;
  animated?: boolean;
}

const CardImageTextArea = (props: ICardImageTextArea) => {
  const { image, topHtml, middleHtml, bottomHtml, addGlint = false, animated = false } = props;

  const pageFullyLoaded: boolean = useSelector((state: IRootState) => state.DreamteamReducer.pageFullyLoaded);
  const ref = useRef<any>(null);

  useEffect(() => {
    // Sometimes fitty will try and calculate the dynamic font size before all the fonts are loaded
    // - to avoid this we've added the load event listener.
    handlePlayerNameDynamicSizing();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [animated, pageFullyLoaded]);

  const handlePlayerNameDynamicSizing = () => {
    const animatedCardElement = document?.querySelector('.card-animated-content');
    const scaleUpBy = animatedCardElement ? parseFloat(getComputedStyle(animatedCardElement)?.getPropertyValue('--scaled-up-by')) : 4;
    const playerNameElement = ref?.current?.querySelector('.card__player-name');

    if (playerNameElement) {
      fitty('.card__player-name', {
        minSize: 10 * scaleUpBy,
        maxSize: Math.min(20 * scaleUpBy, 64)
      });
    }
  };

  return (
    <div className="card-image-text-area" ref={ref}>
      <div className="card-image-text-area__img" style={{ backgroundImage: `url("${image}")` }} />
      <div className="card-image-text-area__copy-container">
        <div className="card-image-text-area__top-html">{topHtml}</div>
        <div className="card-image-text-area__middle-html">{middleHtml}</div>
        <div className="card-image-text-area__bottom-html">{bottomHtml}</div>
      </div>
      {addGlint && <div className="card-image-text-area__glint" />}
    </div>
  );
};

export default CardImageTextArea;
